import { Box, Tabs, TabList, TabPanels, Tab, TabPanel } from '@chakra-ui/react';
import { memo } from 'react';
import ReviewPengetahuan from './Review';
import Diskusi from './Diskusi';
import { usePengetahuanDetailContext } from '../../controller/pengetahuan/detail';
import { useDiskusiContext } from '../../controller/pengetahuan/diskusi';

type ReviewDiskusiTabsProps = {
  readOnlyDiskusi?: boolean;
};

const ReviewDiskusiTabs = memo(({ readOnlyDiskusi = true }: ReviewDiskusiTabsProps) => {
  const { pengetahuanItem } = usePengetahuanDetailContext().state;
  const { state: diskusiState } = useDiskusiContext();
  const diskusiCount = diskusiState.diskusiList.length;

  return (
    <Box mt={4} bg="white" rounded="lg" p={4}>
      <Tabs variant="unstyled">
        <TabList gap={2}>
          <Tab
            _selected={{
              color: 'white',
              bg: 'gray.700',
            }}
            bg="white"
            color="gray.600"
            fontWeight="medium"
            fontSize="sm"
            px={6}
            py={2}
            rounded="md"
            border="1px"
            borderColor="gray.300"
            _hover={{
              bg: 'gray.50',
            }}
          >
            Reviews ({pengetahuanItem?.review_count || 14})
          </Tab>
          <Tab
            _selected={{
              color: 'white',
              bg: 'gray.700',
            }}
            bg="white"
            color="gray.600"
            fontWeight="medium"
            fontSize="sm"
            px={6}
            py={2}
            rounded="md"
            border="1px"
            borderColor="gray.300"
            _hover={{
              bg: 'gray.50',
            }}
          >
            Diskusi ({diskusiCount})
          </Tab>
        </TabList>

        <TabPanels>
          <TabPanel p={0} pt={4}>
            <ReviewPengetahuan noWrapper={true} />
          </TabPanel>
          <TabPanel p={0} pt={4}>
            <Diskusi 
              readOnly={readOnlyDiskusi} 
              noWrapper={true} 
              pengetahuanId={pengetahuanItem?.id || 0}
            />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
});

ReviewDiskusiTabs.displayName = 'ReviewDiskusiTabs';

export default ReviewDiskusiTabs;
